import type { ApiSmsProvider } from '@/api/conversations/types/index.ts';
import Model from './Model.js';

export type { ApiSmsProvider } from '@/api/conversations/types/index.ts';

export default class ConversationSmsProvider extends Model {
    declare id: number;

    declare phone: string;

    static get defaults() {
        return {
            id: 0,
            phone: '',
        };
    }

    static fromApi(smsProvider: ApiSmsProvider): ConversationSmsProvider {
        return new ConversationSmsProvider({
            id: smsProvider.id,
            phone: smsProvider.phone,
        });
    }

    constructor(initialValues: Partial<ConversationSmsProvider> = {}) {
        super(initialValues);
    }
}
